import { render, staticRenderFns } from "./BoundApiPictureIndex.vue?vue&type=template&id=37532e13&"
import script from "./BoundApiPictureIndex.vue?vue&type=script&lang=js&"
export * from "./BoundApiPictureIndex.vue?vue&type=script&lang=js&"
import style0 from "./BoundApiPictureIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports